import 'snapsvg'

import escapeRegExp from '../utils/escapeRegExp'
import formatPhoneNumber from '../utils/formatPhoneNumber'
import getBase64FromImageUrl from '../utils/getBase64FromImageUrl'
import getSvgFonts from '../utils/getSvgFonts'
import adjustAname from '../utils/adjustAname'
import adjustFontSizeToFit from '../utils/adjustFontSizeToFit'
import adjustInfoVertical from '../utils/adjustInfoVertical'
import adjustLetterSpacing from '../utils/adjustLetterSpacing'

const svgns = 'http://www.w3.org/2000/svg'
const xlinkns = 'http://www.w3.org/1999/xlink'
const imageProxyHost = 'https://images.weserv.nl'
const inputDpi = 72
const outputDpi = 300

export default class SVGView {
  constructor({
    svgView,
    photoUrl,
    logoUrl,
    content,
  }) {
    this.load = this.load.bind(this)
    this.toSVG = this.toSVG.bind(this)
    this.toDataURL = this.toDataURL.bind(this)
    this.exportForPrint = this.exportForPrint.bind(this)
    this.resizeToViewBox = this.resizeToViewBox.bind(this)
    this.prepareForPrint = this.prepareForPrint.bind(this)
    this.getResizedImageUrl = this.getResizedImageUrl.bind(this)
    this.parse = this.parse.bind(this)
    this.setContent = this.setContent.bind(this)
    this.setPhoto = this.setPhoto.bind(this)
    this.setLogo = this.setLogo.bind(this)
    this.getSVG = this.getSVG.bind(this)
    this.addCmykColors = this.addCmykColors.bind(this)
    this.addDieCutColor = this.addDieCutColor.bind(this)
    this.setSpacing = this.setSpacing.bind(this);
    this.svgView = svgView
    this.$svgView = document.querySelector(svgView)
    this.content = content
    this.photoUrl = photoUrl
    this.logoUrl = logoUrl
  }

  load(url) {
    return new Promise((resolve) => {
      Snap.load(url, (fragment) => {
        const svg = new Snap(this.svgView)
        svg.append(fragment)
        this.fragment = svg.select('svg')

        const originalWidth = this.fragment.node.style.width
        const originalHeight = this.fragment.node.style.height
        this.fragment.node.style.width = 0
        this.fragment.node.style.height = 0

        this.parse();
        this.setSpacing();

        this.setContent(this.content);

        





        if (this.elements.photo.element) {
          this.originalPhotoUrl = this.elements.photo.element.attr('href') || this.elements.photo.element.attr('xlink:href')
          this.photoUrl = this.photoUrl ? this.photoUrl : this.originalPhotoUrl
          console.log('photoURL: '+this.photoUrl)
          if(this.photoUrl === undefined || this.photoUrl === null){
            
          }else{
            this.setPhoto(this.photoUrl)
          }
          
        }
        if (this.elements.alogo.element) {
          this.originalLogoUrl = this.elements.alogo.element.attr('href') || this.elements.alogo.element.attr('xlink:href')
          this.logoUrl = this.logoUrl ? this.logoUrl : this.originalLogoUrl
          console.log('logoURL: '+this.logoUrl)
          if(this.logoUrl === undefined || this.logoUrl === null){
            
          }else{
            this.setLogo(this.logoUrl)
          }
          
        }

        this.fragment.node.style.width = originalWidth
        this.fragment.node.style.height = originalHeight

        resolve(this)
      })
    })
  }

  toSVG() {
    const svg = new Snap(this.svgView)
    svg.append(this.fragment)
  }

  toDataURL({
    fontsBaseUrl
  }) {
    const embedPhoto = getBase64FromImageUrl(this.photoUrl)
      .then((dataUrl) => {
        this.setPhoto(dataUrl)
      })

    const embedLogo = getBase64FromImageUrl(this.logoUrl)
      .then((dataUrl) => {
        this.setLogo(dataUrl)
      })

    const embedFonts = Promise.all(getSvgFonts(this.fragment.outerSVG())
        .map(font => (
          window.fetch(`${fontsBaseUrl}/${font}.${window.supportsWoff2 ? 'woff2' : 'woff'}`, {
            mode: 'cors'
          })
          .then(response => response.blob())
          .then(blob => new Promise((resolve) => {
            const reader = new FileReader()

            reader.addEventListener('load', () => {
              resolve(reader.result)
            })
            reader.readAsDataURL(blob)
          }))
          .then(dataUrl => `
            @font-face {
              font-family: '${font}';
              src: url('${dataUrl}') format('${window.supportsWoff2 ? 'woff2' : 'woff'}');
            }
          `)
        ))
      )
      .then((fontFaceRules) => {
        const styleElement = document.createElementNS(svgns, 'style')

        styleElement.innerHTML = `
          /* <![CDATA[ */
          ${fontFaceRules.join('\n')}
          /* ]]> */
        `

        this.fragment.prepend(styleElement)
      })

    return Promise.all([
      embedPhoto,
      embedLogo,
      embedFonts,
    ])
      .then(() => (
        `data:image/svg+xml;charset=utf-8,${encodeURIComponent(this.fragment.outerSVG())}`
      ))
  }

  exportForPrint({
    photoUrl,
    logoUrl
  } = {}) {
    this.resizeToViewBox()
    this.toSVG()
    this.prepareForPrint()

    if (this.elements.photo.element && photoUrl) {
      const resizedUrl = this.getResizedImageUrl({
        imageUrl: photoUrl,
        imageElement: this.elements.photo.element,
      })

      this.setPhoto(resizedUrl.toString())
    }

    if (this.elements.alogo.element && logoUrl) {
      const resizedUrl = this.getResizedLogoUrl({
        imageUrl: logoUrl,
        imageElement: this.elements.alogo.element,
      })

      this.setLogo(resizedUrl.toString())
    }

    return this.getSVG({
      embedImages: true,
      convertColors: true,
    })
  }

  resizeToViewBox() {
    const {
      width,
      height
    } = this.fragment.attr('viewBox')

    this.fragment.node.style.width = `${width}px`
    this.fragment.node.style.height = `${height}px`
  }

  prepareForPrint() {
    this.fragment.node.setAttributeNS(svgns, 'color-rendering', 'optimizeQuality')
    this.fragment.selectAll('image').forEach((imageElement) => {
      imageElement.node.setAttributeNS(svgns, 'image-rendering', 'optimizeQuality')
    })

    for (const key in this.elements) {
      const {
        type,
        element,
        elementbis
      } = this.elements[key]

      if (type === 'text' && element && element.node.style.textTransform === 'uppercase') {
        element.node.innerHTML = element.node.innerHTML.toUpperCase()
        var elementb = this.fragment.select('' + elementbis + ' text');
        if (elementb != null) {
          elementb.node.innerHTML = elementb.node.innerHTML.toUpperCase()
        }
      }
    }
  }

  getResizedImageUrl({
    imageUrl,
    imageElement
  }) {
    const url = new URL(imageProxyHost)

    const schemeColonPos = imageUrl.indexOf('://')
    const scheme = imageUrl.substring(0, schemeColonPos)

    url.searchParams.append('url', `${scheme === 'https' ? 'ssl:' : ''}${imageUrl.substring(schemeColonPos + 3)}`)

    const {
      width,
      height,
    } = imageElement.node.getBoundingClientRect()

    url.searchParams.append('w', Math.round(width / inputDpi * outputDpi))
    url.searchParams.append('h', Math.round(height / inputDpi * outputDpi))
    url.searchParams.append('t', 'fit')

    return url
  }
  getResizedLogoUrl({
    imageUrl,
    imageElement
  }) {
    const url = new URL(imageProxyHost)

    const schemeColonPos = imageUrl.indexOf('://')
    const scheme = imageUrl.substring(0, schemeColonPos)

    url.searchParams.append('url', `${scheme === 'https' ? 'ssl:' : ''}${imageUrl.substring(schemeColonPos + 3)}`)

    const {
      width,
      height,
    } = imageElement.node.getBoundingClientRect()

    url.searchParams.append('w', Math.round(width / inputDpi * 1000))
    url.searchParams.append('h', Math.round(height / inputDpi * 1000))
    url.searchParams.append('t', 'fit')

    return url
  }

  parse() {
    //alert("ok je lance")
    this.fragment.attr('xmlns:si', 'http://www.superimpression.com/si')

    this.elements = {
      name: {
        label: 'Name',
        type: 'text',
        element: this.fragment.select('#name text'),
        elementbis: '#namebis'
      },
      fname: {
        label: 'First name',
        type: 'text',
        element: this.fragment.select('#fname text'),
        elementbis: '#fnamebis'
      },
      lname: {
        label: 'Last name',
        type: 'text',
        element: this.fragment.select('#lname text'),
        elementbis: '#lnamebis'
      },
      title: {
        label: 'Title',
        type: 'text',
        element: this.fragment.select('#title text'),
        elementbis: '#titlebis'
      },
      alogo: {
        label: 'Agency\'s logo',
        type: 'image',
        element: this.fragment.select('#alogo image'),
        elementbis: '#alogobis'
      },
      atitle: {
        label: 'Agency\'s title',
        type: 'text',
        element: this.fragment.select('#atitle text'),
        elementbis: '#atitlebis'
      },
      aname: {
        label: 'Agency\'s name',
        type: 'text',
        element: this.fragment.select('#aname text'),
        elementbis: '#anamebis'
      },
      aphone: {
        label: 'Agency\'s phone',
        type: 'phone',
        element: this.fragment.select('#aphone text'),
        elementbis: '#aphonebis'
      },
      bphone: {
        label: 'Phone',
        type: 'phone',
        element: this.fragment.select('#bphone text'),
        elementbis: '#bphonebis'
      },
      photo: {
        label: 'Photo',
        type: 'image',
        element: this.fragment.select('#photo image'),
        elementbis: '#photobis'
      },
      bmail: {
        label: 'Mail',
        type: 'text',
        element: this.fragment.select('#bmail text'),
        elementbis: '#bmailbis'
      },
      burl: {
        label: 'Website',
        type: 'text',
        element: this.fragment.select('#burl text'),
        elementbis: '#burlbis'
      },
      date: {
        label: 'Date',
        type: 'text',
        element: this.fragment.select('#date text'),
        elementbis: '#datebis'
      },
      input1: {
        label: 'Input1',
        type: 'text',
        element: this.fragment.select('#input1 text'),
        elementbis: '#input1bis'
      },
      input2: {
        label: 'Input2',
        type: 'text',
        element: this.fragment.select('#input2 text'),
        elementbis: '#input2bis'
      },
      input3: {
        label: 'Input3',
        type: 'text',
        element: this.fragment.select('#input3 text'),
        elementbis: '#input3bis'
      },
      input4: {
        label: 'Input4',
        type: 'text',
        element: this.fragment.select('#input4 text'),
        elementbis: '#input4bis'
      },
      input5: {
        label: 'Input5',
        type: 'text',
        element: this.fragment.select('#input5 text'),
        elementbis: '#input5bis'
      },
      //
    }

    return this
  }

  setSpacing() {
    const styles = this.fragment.selectAll('style');
    const regex = /st(\d{1,3})\{letter-spacing\:(\d+(?:[.]\d+)?)\;\}/g;
    styles.forEach((style) => {
      const str = style.node;
      const htm = str.innerHTML.replace(new RegExp(/st(\d{1,3})\{letter-spacing\:(\d+(?:[.]\d+)?)\;\}/, 'g'), 'st\$1{letter-spacing:\$2px;}')
      str.innerHTML = htm;
    });
    const textes = this.fragment.selectAll('text');
    textes.forEach((texte) => {
      adjustLetterSpacing(texte);
    });

  }
  adjustVertical() {

    this.binfo = this.fragment.select("#binfo");
    if (this.binfo) {
      adjustInfoVertical(this.fragment, false, true);
      //adjustInfoVertical(this.fragment, false, true);
    }

    this.binfobis = this.fragment.select("#binfobis");
    if (this.elementBisOk) {
      adjustInfoVertical(this.fragment, true, true)
      //adjustInfoVertical(this.fragment, true, true)
    }
  }
  adjustAnameAndTitle() {
    this.anameandtitle = this.fragment.select("#anameandtitle");
    if (this.anameandtitle) {
      adjustAname(this.fragment, '');
      //adjustAname(this.fragment, '');
    }

    this.anameandtitlebis = this.fragment.select("#anameandtitlebis");
    if (this.anameandtitlebis) {
      adjustAname(this.fragment, 'bis');
      //adjustAname(this.fragment, 'bis');
    }
  }
  setContent(content) {
    for (const id in content) {
      if (this.elements[id] && this.elements[id].element) {
        const hasPrefix = this.elements[id].element.attr('si:has-prefix') ? this.elements[id].element.attr('si:has-prefix') : ''
        this.elements[id].element.node.innerHTML = hasPrefix + content[id]

        if (this.logoUrl === '' || this.fragment.select("#alogo") === null || this.logoUrl === null) {
          if (this.fragment.select("#alogo") != null) {
            this.fragment.select("#alogo").node.style.display = 'none';
          }
        } else {
          if (id === 'aname' || id === "atitle") {
            this.elements[id].element.node.innerHTML = '';
          }
        }

        if (this.elements[id].type == 'text') {
          var elementbis = this.fragment.select('' + this.elements[id].elementbis + ' text');
          //adjustLetterSpacing(this.elements[id].element);
          adjustFontSizeToFit(this.elements[id].element, false);
          if (elementbis != null) {
            elementbis.node.innerHTML = this.elements[id].element.node.innerHTML
            this.elements[id].element.attr('si:bis', this.elements[id].elementbis);
            //adjustLetterSpacing(elementbis);
            adjustFontSizeToFit(elementbis, false);
          }
        }


        if (this.elements[id].type == "phone" && this.elements[id].element.attr('si:phone-format')) {

          var indic = null;

          if (id == "bphone" && this.fragment.select("#bindic text") !== null) {
            this.elements[id].element.attr('si:indic', 'true')
            this.elements[id].element.attr('si:whichIndic', 'bindic')
            indic = this.fragment.select('#bindic text')
          } else if (id == "aphone" && this.fragment.select("#aindic text") !== null) {
            this.elements[id].element.attr('si:indic', 'true')
            this.elements[id].element.attr('si:whichIndic', 'aindic')
            indic = this.fragment.select('#aindic text')
          }

          const phoneFormat = this.elements[id].element.attr('si:phone-format')
          const hasBindic = this.elements[id].element.attr('si:indic') ? true : false
          const phonePrefix = this.elements[id].element.attr('si:phone-prefix') ? this.elements[id].element.attr('si:phone-prefix') : ''
          //
          const num = formatPhoneNumber(content[id], phoneFormat, phonePrefix, false, hasBindic)
          //
          if (hasBindic) {
            this.elements[id].element.node.innerHTML = num.substr(4, 10);
            var parenthese = indic.node.innerHTML.charAt(0);
            if (parenthese == "(") {
              indic.attr('si:numDeco', "(");
              indic.node.innerHTML = "(";
              indic.node.innerHTML += num.substr(0, 3);
              indic.node.innerHTML += ")";
            } else {
              indic.node.innerHTML = num.substr(0, 3);
            }
            adjustFontSizeToFit(indic, true);
            //double check to work ;)
            adjustFontSizeToFit(indic, true);
            //
            var elementbis = this.fragment.select('' + this.elements[id].elementbis + ' text');
            if (elementbis != null) {
              elementbis.node.innerHTML = this.elements[id].element.node.innerHTML;
              this.elements[id].element.attr('si:bis', this.elements[id].elementbis);
              indic = this.fragment.select('#' + this.elements[id].element.attr('si:whichIndic') + "bis text")
              var parentheseBis = indic.node.innerHTML.charAt(0);
              if (parentheseBis == "(") {
                indic.attr('si:numDeco', "(");
                indic.node.innerHTML = "(";
                indic.node.innerHTML += num.substr(0, 3);
                indic.node.innerHTML += ")";
              } else {
                indic.node.innerHTML = num.substr(0, 3);
              }
              adjustFontSizeToFit(indic, true);
            }
          } else {
            this.elements[id].element.node.innerHTML = num;
            var elementbis = this.fragment.select('' + this.elements[id].elementbis + ' text');
            if (elementbis != null) {
              elementbis.node.innerHTML = this.elements[id].element.node.innerHTML;
              this.elements[id].element.attr('si:bis', this.elements[id].elementbis);
            }
          }

        }
      }
    }
    this.adjustVertical();
    this.adjustAnameAndTitle();
    return this

  }

  setPhoto(photoUrl) {
    if (this.elements.photo.element) {
      this.elements.photo.element.node.removeAttribute('href')
      this.elements.photo.element.node.setAttributeNS(xlinkns, 'href', photoUrl)
      this.photoUrl = photoUrl
      var elementbis = this.fragment.select('' + this.elements.photo.elementbis + ' image');
      //console.log(elements[id].label + " " + elementbis)
      if (elementbis !== null) {
        elementbis.node.removeAttribute('href')
        elementbis.node.setAttributeNS(xlinkns, 'href', photoUrl)
      }
    } else {
      this.photoUrl = null
    }
  }

  setLogo(logoUrl) {
    if (this.elements.alogo.element && this.logoUrl) {
      this.elements.alogo.element.node.removeAttribute('href')
      this.elements.alogo.element.node.setAttributeNS(xlinkns, 'href', logoUrl)
      this.logoUrl = logoUrl
      var elementbis = this.fragment.select('' + this.elements.alogo.elementbis + ' image');

      if (elementbis !== null) {
        elementbis.node.removeAttribute('href')
        elementbis.node.setAttributeNS(xlinkns, 'href', logoUrl)
      }
    } else {
      this.logoUrl = null
    }
  }

  getSVG({
    embedImages = false,
    convertColors = false,
  } = {}) {
    if (embedImages) {
      return Promise.all([
        this.photoUrl ? getBase64FromImageUrl(this.photoUrl).then((dataUrl) => {
            this.setPhoto(dataUrl)
          }) : Promise.resolve(),
        this.logoUrl ? getBase64FromImageUrl(this.logoUrl).then((dataUrl) => {
            this.setLogo(dataUrl)
          }) : Promise.resolve(),
      ])
        .then(() => {
          if (convertColors) {
            this.addDieCutColor()
          }
        })
        .then(() => this.fragment.outerSVG())
        .then(svgString => convertColors ? this.addCmykColors(svgString) : svgString)
    } else {
      const photoUrl = this.photoUrl
      const logoUrl = this.logoUrl

      return new Promise((resolve) => {
          if (this.originalPhotoUrl) {
            this.setPhoto(this.originalPhotoUrl)
          }
          if (this.originalLogoUrl) {
            this.setLogo(this.originalLogoUrl)
          }

          resolve()
        })
        .then(() => {
          if (convertColors) {
            this.addDieCutColor()
          }
        })
        .then(() => this.fragment.outerSVG())
        .then((svgString) => {
          if (photoUrl) {
            this.setPhoto(photoUrl)
          }
          if (logoUrl) {
            this.setLogo(logoUrl)
          }

          return svgString
        })
        .then(svgString => convertColors ? this.addCmykColors(svgString) : svgString)
    }
  }

  addCmykColors(svgString) {
    if (!this.content.replacementPatterns) {
      return svgString
    }

    const replacements = new Map(Object.entries(JSON.parse(this.content.replacementPatterns)).map(([rgbhexa, cmyk]) => (
      [rgbhexa.toUpperCase(), cmyk.split(/\s*,\s*/).map(c => c / 100).join(',')]
    )))
    const pattern = new RegExp('(fill|stroke)\\s*:\\s*(' + Array.from(replacements, ([rgbhexa]) => escapeRegExp(rgbhexa)).join('|') + ');', 'gi')

    return svgString.replace(pattern, (match, property, rgbhexa) => {
      const cmyk = replacements.get(rgbhexa.toUpperCase())

      return `${property}:${rgbhexa} device-cmyk(${cmyk});`
    })
  }

  addDieCutColor() {
    const colorProfileUrl = 'si-die-cut.icc'
    const colorProfileName = 'siDieCut'
    const colorName = 'DieCut'
    const fallbackColor = '#000000'

    const styleElement = document.createElementNS(svgns, 'style')

    styleElement.innerHTML = `
      /* <![CDATA[ */
      #die *, #die rect {stroke:${fallbackColor} icc-named-color(${colorProfileName},${colorName}) !important;}
      /* ]]> */
    `

    this.fragment.prepend(styleElement)

    const colorProfileElement = document.createElementNS(svgns, 'color-profile')

    colorProfileElement.setAttributeNS(svgns, 'name', colorProfileName)
    colorProfileElement.removeAttribute('href')
    colorProfileElement.setAttributeNS(xlinkns, 'href', colorProfileUrl)
    colorProfileElement.setAttribute('xlink:href', colorProfileUrl)

    this.fragment.prepend(colorProfileElement)
  }
}
